export default function deSlugify(slug) {
    if(slug) return slug.replace(/-/g, ' ').toLowerCase();
    else return 'all'
    
}
